var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayCheckMark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 21.5,
    height: 21.5,
    rx: 10.75,
    fill: "#005857",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7071 7.29289C18.0976 7.68342 18.0976 8.31658 17.7071 8.70711L10.0148 16.3994C9.62427 16.7899 8.99111 16.7899 8.60059 16.3994L6.29289 14.0917C5.90237 13.7012 5.90237 13.068 6.29289 12.6775C6.68342 12.287 7.31658 12.287 7.70711 12.6775L9.30769 14.2781L16.2929 7.29289C16.6834 6.90237 17.3166 6.90237 17.7071 7.29289Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayCheckMark);
export default __webpack_public_path__ + "static/media/GrayCheckMark.b47f0b9c.svg";
export { ForwardRef as ReactComponent };